import React, { createContext, useState, useContext } from 'react';

// 创建默认值对象
const defaultContextValue = {
  activeTickerId: '',
  setActiveTickerId: () => {}
};

// 确保上下文对象在模块加载时创建
const ActiveTickerContext = createContext(defaultContextValue);

// 安全访问上下文的方法
export const getActiveTickerContext = () => {
  if (!ActiveTickerContext) {
    console.error('ActiveTickerContext is not defined!');
    return createContext(defaultContextValue);
  }
  return ActiveTickerContext;
};

export const ActiveTickerProvider = ({ children }) => {
  const [activeTickerId, setActiveTickerId] = useState('');

  return (
    <ActiveTickerContext.Provider value={{ activeTickerId, setActiveTickerId }}>
      {children}
    </ActiveTickerContext.Provider>
  );
};

// 使用默认值的上下文钩子
export const useActiveTicker = () => {
  try {
    const context = useContext(ActiveTickerContext);
    return context || defaultContextValue;
  } catch (error) {
    console.error('useActiveTicker error:', error);
    return defaultContextValue;
  }
};
